import PrivateVars from "../PrivateVars";
import Color from "../Color";

function initWebGL(canvas) {

    // 
    let version = undefined;
    let gl = undefined;

    // Get WebGL 2.0
    gl = canvas.getContext('webgl2');
    version = 2.0;

    // Get WebGL 1.0 ( if 2.0 is unavailable )
    if (!gl) {
        gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        version = 1.0;
    }

    // Unable to get a WebGL context, give up now
    if (!gl) {
        alert('Unable to initialize WebGL. Your browser may not support it.');
        version = undefined;
        gl = undefined;
    }

    return [gl, version];
}

function GetDefaultScreenShader(renderer) {
    //
}

export default class Renderer {

    constructor(canvas) {
        // Get JQuery Reference to Canvas
        this.canvas = $(canvas);

        // Get WebGL Context
        [this.gl, this.version] = initWebGL(this.canvas[0]);

        // 
        PrivateVars.set(this, 'resources', new WeakMap());

        const gl = this.gl;

        // == Defaults WebGL

        // Set viewport
        this.setViewport(0, 0, gl.canvas.width, gl.canvas.height);

        // 
        gl.enable(gl.DEPTH_TEST);
        gl.depthFunc(gl.LEQUAL);

        // 
        gl.disable(gl.CULL_FACE);
        gl.cullFace(gl.FRONT_AND_BACK);

        // Set clear color based on version ( 2.0 is pink )
        if (this.version == 1) this.setClearColor([0.33, 0.66, 1.0, 1.0])
        else this.setClearColor([1.0, 0.33, 0.66, 1.0]);
        this.setClearDepth(1.0);

        // 
        this.clear();
    }

    setViewport(x1, y1, x2, y2) {
        let gl = this.gl;
        // console.debug(`Setting Viewport: ${x1}, ${y1}, ${x2}, ${y2}`);
        gl.viewport(x1, y1, x2, y2);
    }

    setDepthFunction(func) {
        let gl = this.gl;
        if (func === gl.ALWAYS) {
            gl.disable(gl.DEPTH_TEST);
            gl.depthFunc(func);
        } else {
            gl.enable(gl.DEPTH_TEST);
            gl.depthFunc(func);
        }
    }

    /**
     * Sets the depth value used during a clear operation ( if the depth bit is present ).
     * @param {number} depth 
     */
    setClearDepth(depth) {
        let gl = this.gl;
        gl.clearDepth(depth);
    }

    /**
     * Sets the color used during a clear operation ( if the color bit is present ).
     * @param {string|Array} color 
     */
    setClearColor(color) {
        let gl = this.gl;
        color = Color.parse(color);
        gl.clearColor(color[0], color[1], color[2], color[3]);
    }

    /**
     * Clear the currently bound framebuffer.
     */
    clear(bits) {
        let gl = this.gl;
        if (!bits) bits = gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT;
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
    }

    /**
     * 
     * @param {(Framebuffer|Texture)} framebuffer A valid framebuffer or texture.
     */
    blit(framebuffer, shader, uniforms) {

        if (!framebuffer)
            throw new Error("Unable to blit framebuffer, invalid argument given.");

        shader = shader || GetDefaultScreenShader(this);
        if (uniforms) {
            // Apply them
        }

        // Blit Framebuffer ( Draw screen quad )
        // <draw 2d quad>
    }
};